// extracted by mini-css-extract-plugin
export default {"container":"qUCWAUkM","backButtonContainer":"vLWbwgHj","backButton":"DEYPG86E"};